import { render, staticRenderFns } from "./licencaStatus.vue?vue&type=template&id=6e2360e6&scoped=true&"
import script from "./licencaStatus.vue?vue&type=script&lang=js&"
export * from "./licencaStatus.vue?vue&type=script&lang=js&"
import style0 from "./licencaStatus.vue?vue&type=style&index=0&id=6e2360e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2360e6",
  null
  
)

export default component.exports